import React from 'react';
import { jwtDecode } from 'jwt-decode';
import { getRolesFromToken } from '../../utils/auth';
import { ROLES } from '../../utils/roles';
import UsuarioForm from '../../components/UsuarioForm';

const MisDatos = () => {
    const token = localStorage.getItem('jwt');

    if (!token) {
        return <p className="text-sm text-gray-500 text-center py-10">No hay sesion activa. Por favor, inicia sesion.</p>;
    }

    const decoded = jwtDecode(token);
    const roles = getRolesFromToken(token);

    const empleadoEmail = decoded.sub;
    const esPropietario = roles.includes(ROLES.PROPIETARIO);
    const esEmpleado = roles.includes(ROLES.EMPLEADO) || esPropietario;

    if (!esEmpleado) {
        return <p className="text-sm text-gray-500 text-center py-10">No tenes permisos para ver esta seccion.</p>;
    }

    return (
        <div className="max-w-md mx-auto">
            <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-6">
                <UsuarioForm emailUsuarioActual={empleadoEmail} rol={esPropietario ? ROLES.PROPIETARIO : ROLES.EMPLEADO} />
            </div>
        </div>
    );
};

export default MisDatos;
